export default __webpack_public_path__ + "static/media/total-sales.750ee814.svg";